import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from '../../../store'
import AssignTags from './AssignTags'

const mapStateToProps = state => ({
  table: state.storage.table,
  tags: state.tag.list,
  uploadedTable: state.upload.uploadedTable
})

const mapDispatchToProps = dispatch => bindActionCreators({
  addTag: actions.storage.addTag,
  removeTag: actions.storage.removeTag,
  updateTable: actions.storage.updateTable,
  getStorage: actions.storage.getStorage,
  createTag: actions.tag.createTag,
  uploadedFileHandleTag: actions.upload.uploadedFileHandleTag
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignTags)



// WEBPACK FOOTER //
// ./src/components/Parts/AssignTags/index.js